import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Wine, Plus, Construction } from "lucide-react";

const LicoresRegistro = () => {
  return (
    <div className="space-y-6" data-testid="licores-registro-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 bg-amber-100 rounded-lg flex items-center justify-center">
            <Wine className="w-6 h-6 text-amber-700" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Registro de Licores</h1>
            <p className="text-sm text-slate-500">
              Gestión de contribuyentes con actividad de venta/distribución de licores
            </p>
          </div>
        </div>
        <Button disabled className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="btn-new-licor">
          <Plus className="w-4 h-4 mr-2" /> Nuevo Registro
        </Button>
      </div>

      <Card className="border-dashed border-2 border-slate-300">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-slate-700">
            <Construction className="w-5 h-5 text-amber-600" /> Submódulo en construcción
          </CardTitle>
          <CardDescription>
            Los campos del formulario serán definidos próximamente. Este submódulo incluirá:
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="text-sm text-slate-600 space-y-2 list-disc ml-5">
            <li>Datos del contribuyente (RIF, razón social, domicilio fiscal)</li>
            <li>Datos del establecimiento (nombre comercial, dirección, tipo de expendio)</li>
            <li>Licencia / permiso de expendio de licores</li>
            <li>Código y clasificación de licores (vinculado a submódulo Códigos)</li>
            <li>Fecha de inicio de actividades</li>
            <li>Horarios de operación</li>
            <li>Estatus del registro (Activo / Inactivo / Suspendido)</li>
          </ul>
          <p className="mt-4 text-xs text-slate-400 italic">
            Comparta los campos específicos con el equipo de desarrollo para habilitar este submódulo.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LicoresRegistro;
